import styled from 'styled-components';

export const TabPanelEmptyState = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 200px;
`;
